export default __webpack_public_path__ + "static/media/img_star_show.754c1945.png";